import React, { Component } from 'react';

import Dialog from '../../../raven/modals/dialog';
import SupportedPidView from './supportedPidView';

export default class SupportedPidsModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pids: [],
            loading: true
        };
    }

    getSupportedPids() {
        // perform ajax calls to get it the next state
        let url = "" + this.props.dataStore.prefix1 + "ajaxbig"
                + "?stage=" + this.props.stage
                + "&type=obdpids"
                + "&raven=" + this.props.raven.raven_id;

        this.props.dataStore.queryLoop(url, (items) => {
            this.setState({
                pids: items,
                loading: false
            });
        });
    }

    componentDidMount() {
        this.getSupportedPids();
    }

    render() {

        return (
            <Dialog
                size="medium"
                className="test"
                label={this.props.title}
                isOpen={this.props.isOpen}
                onClose={this.props.onClose}
                >
                    <div>
                        <div className="row">
                            <div className="col-12">
                                {
                                    this.state.pids && !this.state.loading ?
                                        this.state.pids.length !== 0 ?
                                            <SupportedPidView
                                                data={this.state.pids}
                                            /> :
                                            <p>No PID Data...</p> :
                                        <p>Loading...</p>
                                }
                            </div>
                        </div>
                    
                    </div>
            </Dialog>
        );
    }

}
